import { Tabs, Tab } from "@mui/material";
import { useRouter } from "next/router";
import * as T from "common/src/bindings/Translation2";

export default function DropTablesNav({ route }: { route: string }) {
  const router = useRouter();
  return (
    <div className="px-3 pt-2 pb-0 mb-3 sticky top-[48px] md:top-[92px] bg-bg0 z-20">
      <Tabs
        value={route}
        variant="scrollable"
        onChange={(_, t) => {
          switch (t) {
            case "Bilgewater":
              router.push("/info/set-16/tables/bilgewater");
              break;
            case "Ixtal":
              router.push("/info/set-16/tables/ixtal");
              break;
            case "NineLives":
              router.push("/info/set-16/tables/nine-lives");
              break;
            case "Gloryseeker":
              router.push("/info/set-16/tables/gloryseeker");
              break;
            case "TreasureHunt":
              router.push("/info/set-16/tables/treasure-hunt");
              break;
            // case "Double Up":
            //   router.push("/info/set-16/tables/double-up");
            //   break;
            case "Augments":
              router.push("/info/set-16/tables/augments");
              break;
            case "LootOrbs":
              router.push("/info/set-16/tables/loot-orbs");
              break;
            case "Reroll":
              router.push("/info/set-16/tables/reroll");
              break;
            case "Golden Egg":
              router.push("/info/set-16/tables/golden-egg");
              break;
            case "Loot Subscription":
              router.push("/info/set-16/tables/loot-subscription");
              break;
            case "Call to Chaos":
              router.push("/info/set-16/tables/call-to-chaos");
              break;
            case "Magic Roll":
              router.push("/info/set-16/tables/magic-roll");
              break;
            case "Expected Unexpectedness":
              router.push("/info/set-16/tables/expected-unexpectedness");
              break;
          }
        }}
      >
        <Tab label={T.common("Augments")} value="Augments" />
        <Tab label={T.augments("11Calltochaos")} value="Call to Chaos" />
        {/* <Tab label={T.traits("TFT16_Bilgewater")} value="Bilgewater" /> */}
        <Tab label={T.traits("TFT16_Explorer")} value="Ixtal" />
        <Tab
          label={T.augments("ExpectedUnexpectedness")}
          value="Expected Unexpectedness"
        />
        {/* <Tab label={T.augments("Gloryseeker")} value="Gloryseeker" /> */}
        <Tab label={T.common("Golden Egg")} value="Golden Egg" />
        <Tab label={T.common("Loot Orbs")} value="LootOrbs" />
        <Tab
          label={T.common("TFT_Portals_Unique_LootSubscription")}
          value="Loot Subscription"
        />
        <Tab label={T.augments("MagicRoll")} value="Magic Roll" />
        <Tab label={T.augments("Nine Lives")} value="NineLives" />
        <Tab label={T.common("Reroll")} value="Reroll" />
        <Tab label={T.augments("TreasureHunt")} value="TreasureHunt" />
      </Tabs>
    </div>
  );
}
